import api from "@/api";
import store from '@/store'
import router from '@/router'

/**
 * 通用上报用户浏览记录
 * 未登录时不上报，直接返回
 * @param {Object} params 上报参数
 * @param {number} params.ProductType 产品类型 1.PCP产品 2.PCP岸上观光产品 3.航线
 * @param {number} params.ProductId 根据ProductType显示对应产品Id
 * @param {number} params.SceneType 场景类型 1.浏览 2.筛选
 * @param {Array<string>} params.Parameters 附加参数，查询或浏览的入参，例如['上海','首尔仁川','2026-07']
 * @returns {Promise|undefined} 
 */
export const reportUserBrowsingRecord = (params = {}) => {
  const userToken = store.state.user.userToken;
  // 未登录不上报
  if (!userToken) return;
  return api.user.createUserBrowsingRecord(params);
}

export const jumpOnlineService = ()=> {
    // 先校验登录状态，未登录则跳转登录页
    const userToken = store.state.user.userToken;
    if (!userToken) {
        // 复用当前 URL 中已有的 returnUrl，避免多次点击客服按钮导致 returnUrl 重复叠加编码
        const searchParams = new URLSearchParams(location.search);
        const returnUrl = searchParams.get('returnUrl') || encodeURIComponent(location.href);
        router.push({
            name: 'Login',
            query: {
                returnUrl
            }
        });
        return;
    }

    // 聊天窗口配置
    const CHAT_WINDOW_CONFIG = {
        name: 'newwindow',
        features: 'height=400,width=400'
    };

    // 默认聊天URL
    const DEFAULT_CHAT_URL = 'http://rcclchina.udesk.cn/im_client?web_plugin_id=23600';

    const openChatWindow = (url) => {
        window.open(url, CHAT_WINDOW_CONFIG.name, CHAT_WINDOW_CONFIG.features);
    };

    api.page.getUDeskUrl({
        userName: userToken || "",
        source: 'PC'
    })
    .then((res) =>{
        const { success, data } = res;
        const chatUrl = success ? (data || DEFAULT_CHAT_URL) : DEFAULT_CHAT_URL;
        openChatWindow(chatUrl);
    }).catch(() => {
        openChatWindow(DEFAULT_CHAT_URL);
    });
}